import React from 'react'
import { useHistory } from 'react-router-dom'
import { useToaster } from 'utils/useToaster'
import { ResetPasswordCard } from 'sharedComponents/ResetPasswordCard'
import { EmptyCenteredLayout } from 'client-portal/components/PageLayout'

const ResetPassword: React.VFC = () => {
  const history = useHistory()
  const { setToastMessage } = useToaster()

  return (
    <EmptyCenteredLayout>
      <ResetPasswordCard
        title="Reset password"
        newPasswordLabel="New password"
        newPasswordPlaceholder="Enter new password"
        newPasswordConfirmationLabel="Password confirmation"
        newPasswordConfirmationPlaceholder="Enter password again"
        resetPasswordButtonLabel="Reset password"
        signInButtonLabel="Sign in"
        onSignInButtonClick={() => history.push('/')}
        onSuccess={() => {
          history.push('/')
          setToastMessage('Password successfully changed', 'success')
        }}
      />
    </EmptyCenteredLayout>
  )
}

export { ResetPassword }
